import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import { AppBar, Box, Container, Toolbar } from "@mui/material";
import theme from "@theme";

const DrawerContent = styled(Box)`
  padding: 5px;
  display: flex;
  flex-direction: row !important;
  justify-content: center;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
`;

const StyledContainer = styled(Container)`
  padding: 0px 10px 0px 10px !important;
`;

const StyledToolbar = styled(Toolbar)`
  padding: unset !important;
`;

const menuItem = {
  flexGrow: 1,
  display: {
    xs: "none",
    md: "flex",
  },
  marginLeft: "150px",
};
const menuTab = {
  display: "flex",
};

const globalStyles = css`
  .MuiAppBar-root {
    background-color: white !important;
    position: fixed !important;
  }

  .MuiMenu-list {
    padding: 0px !important;
  }

  .MuiPopover-paper {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important; /* Minimal box shadow */
    border: 2px solid ${theme.colors.bordertask};
  }
`;

const ProfileItem = styled(Box)`
  display: flex;
  align-items: center;
`;

const StyledAppBar = styled(AppBar)`
  border-bottom: 2px solid #f0f0f0;
  background-color: ${theme.colors.white};
  color: black;
  position: static;
  box-shadow: none !important;
  elevation: 0;
`;

const BoxContainer = styled(Box)`
  max-height: 300px;
  width:190px;
  display: flex;
  flex-direction: column;
justifyContent: "center", 
alignItems: "center", 
  margin-left: 5px;

  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: ${theme.colors.bordertask};
  }
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 10px;
  }
`;

const SC = {
  menuItem,
  ProfileItem,
  menuTab,
  DrawerContent,
  StyledContainer,
  StyledToolbar,
  StyledAppBar,
  BoxContainer,
  Globalstyles: <Global styles={globalStyles} />,
};

export default SC;
